module.exports = __webpack_public_path__ + "img/Anuj, Co-Director of Corporate Relations.0dd82f1d.webp";